/**
 * Display-Only Product Blocker
 * Prevents products tagged with "status:display-only" from being added to cart
 * This acts as a safety net in case any AJAX or programmatic cart additions are attempted
 */

(function() {
  'use strict';

  // Get product data from the page
  function getProductData() {
    // Try to find product data in meta tags or global variables
    if (typeof window.ShopifyAnalytics !== 'undefined' && 
        window.ShopifyAnalytics.meta && 
        window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product;
    }
    
    // Fallback: check for product JSON in script tag
    const productScript = document.querySelector('script[type="application/json"][data-product-json]');
    if (productScript) {
      try {
        return JSON.parse(productScript.textContent);
      } catch (e) {
        console.warn('Could not parse product JSON', e);
      }
    }
    
    return null;
  }

  // Check if product has display-only tag
  function isDisplayOnly() {
    const product = getProductData();
    if (!product || !product.tags) return false;
    
    // Check for the display-only tag (handle different tag formats)
    return product.tags.some(tag => 
      tag.toLowerCase().includes('display-only')
    );
  }

  // Block form submission for display-only products
  function blockAddToCart() {
    if (!isDisplayOnly()) return;

    // Block standard form submissions
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        console.log('Blocked: This product is display-only');
        return false;
      });
    });

    // Block any add to cart buttons
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart], [name="add"]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Blocked: This product is display-only');
        return false;
      }, true);
    });

    // Intercept fetch requests to /cart/add.js
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      if (typeof url === 'string' && url.includes('/cart/add')) {
        console.log('Blocked AJAX cart add: This product is display-only');
        return Promise.reject(new Error('This product is display-only and cannot be added to cart'));
      }
      return originalFetch.apply(this, args);
    };

    // Intercept XMLHttpRequest to /cart/add.js
    const originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      if (url.includes('/cart/add')) {
        console.log('Blocked XHR cart add: This product is display-only');
        throw new Error('This product is display-only and cannot be added to cart');
      }
      return originalXHROpen.call(this, method, url, ...rest);
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', blockAddToCart);
  } else {
    blockAddToCart();
  }

})();